export class SendMailModel {
FormMailContent:string;
FormMailSubject:string;
FormMailCC:string;
FormMailEmpId:number;
}